import React from "react";

const RuleLayout = ({ title, children }) => {
  return (
    <div className="w-full min-h-screen bg-[#222222]">
      <div className="max-w-7xl mx-auto pt-16 pb-8 px-3 sm:px-6 lg:px-8">
        <div className="p-0 sm:p-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-white text-center mb-6">
            {title}
          </h1>
          {children}
        </div>
      </div>
    </div>
  );
};

export default RuleLayout;
